import { BatchedRenderer } from "three.quarks";
import { GameResourcesPackage } from "../../../../../resources/GameResourcesPackage";
import { BoxLandingParticle } from "../../particles/BoxLandingParticle";
import { Box } from "../Box";
import { IBoxState } from "./IBoxState";

export class BoxSpawnState implements IBoxState {
    private particle: BoxLandingParticle;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly batchRenderer: BatchedRenderer,
        private readonly box: Box,
        private readonly nextState: IBoxState
    ) { }
    public enter(_previousState: IBoxState): void {
    }
    public exit(): void {
        this.particle = new BoxLandingParticle(this.gameResources, this.batchRenderer);
        this.particle.position.set(0, 0.05, 0);
        this.box.parent.add(this.particle);
        this.particle.play();
        this.box.position.set(0, 0, 0);
        this.box.removeParachute();
    }
    public process(_dt: number): IBoxState {
        this.box.position.y = Math.max(this.box.position.y - (0.005 * _dt), 0);
        if (this.box.position.y == 0) {
            return this.nextState;
        }
        return this;
    }
}